import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, alpha, darken, lighten, Typography, useTheme } from '@mui/material';

export const Banner = ({ text, icon, color = 'info', children }) => {
  const theme = useTheme();
  let baseColor = theme.color(color);

  const bg = theme.palette.mode === 'dark' ? darken(baseColor, 0.9) : lighten(baseColor, 0.8);
  const fg = theme.palette.mode === 'dark' ? lighten(baseColor, 0.35) : darken(baseColor, 0.35);

  return (
    text && (
      <Alert
        icon={icon ? <FontAwesomeIcon color={fg} icon={icon} /> : undefined}
        sx={{
          backgroundColor: bg,
          color: fg,
          WebkitTextFillColor: fg,
          border: theme.palette.mode === 'dark' ? `1px solid ${alpha(fg, 0.4)}` : undefined,
        }}
        action={children}
      >
        <Typography component={'span'}>{text}</Typography>
      </Alert>
    )
  );
};
